<template>
  <div class="top-products">
    <doughnut-chart :chart-data="chartData"></doughnut-chart>
  </div>
</template>

<script>
import DoughnutChart from "@/components/admin/dashboard/charts/DoughnutChart";
export default {
  name: "TopPaymentsChart",
  components: { DoughnutChart },
  props: {
    orders: {
      type: Array,
      default: null
    }
  },
  computed: {
    chartData() {
      let labels = [];
      let dataPercentage = [];
      let data = [];
      let totalDatafonoUsers = this.orders.reduce(
        (acc, n) => acc + n.cntDatafono || 0,
        0
      );
      let totalGpayUsers = this.orders.reduce(
        (acc, n) => acc + n.cntGpay || 0,
        0
      );
      let totalApplePayUsers = this.orders.reduce(
        (acc, n) => acc + n.cntApplePay || 0,
        0
      );
      let totalBizumUsers = this.orders.reduce(
        (acc, n) => acc + n.cntBizum || 0,
        0
      );
      let totalEfectivoUsers = this.orders.reduce(
        (acc, n) => acc + n.cntCash || 0,
        0
      );
      let totalCardUsers = this.orders.reduce(
        (acc, n) => acc + n.cntCreditCard || 0,
        0
      );
      let sumData =
        totalDatafonoUsers +
        totalGpayUsers +
        totalApplePayUsers +
        totalBizumUsers +
        totalEfectivoUsers +
        totalCardUsers;

      let resultObj = {
        datafono: {
          value: totalDatafonoUsers,
          label: "Tarjeta de crédito (Datáfono)"
        },
        googlepay: { value: totalGpayUsers, label: "Google Pay" },
        credit_card: { value: totalCardUsers, label: "Tarjeta de crédito" },
        bizum: { value: totalBizumUsers, label: "Bizum" },
        applepay: { value: totalApplePayUsers, labe: "Apple Pay" },
        cash: { value: totalEfectivoUsers, label: "Efectivo" }
      };
      for (const [key, value] of Object.entries(resultObj)) {
        if (key === "datafono" && value.value > 0) {
          data.push(value.value);
          labels.push(value.label);
        }
        if (key === "googlepay" && value.value > 0) {
          data.push(value.value);
          labels.push(value.label);
        }
        if (key === "credit_card" && value.value > 0) {
          data.push(value.value);
          labels.push(value.label);
        }
        if (key === "bizum" && value.value > 0) {
          data.push(value.value);
          labels.push(value.label);
        }
        if (key === "applepay" && value.value > 0) {
          data.push(value.value);
          labels.push(value.label);
        }
        if (key === "cash" && value.value > 0) {
          data.push(value.value);
          labels.push(value.label);
        }
      }
      data?.forEach(d => {
        dataPercentage.push(((d * 100) / sumData).toFixed(1));
      });
      return {
        labels: labels,
        datasets: [
          {
            data: dataPercentage,
            backgroundColor: [
              "#ad2664",
              "#e2662e",
              "#953c86",
              "#20c997",
              "#02d6ef",
              "#7b00ff",
              "#ba72bf",
              "#99635f",
              "#3ABC88",
              "#0677e8"
            ],
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
